import { h } from '../';
export const selectTransactionAccounts = (state) => {
    const count = state.transactionAccounts;
    if (!h.hasData(count)) {
        return null;
    }
    return count.data;
};
export const selectTransactionImportById = (state, id) => {
    const transactionImport = state.transactionImports[id];
    if (!h.hasData(transactionImport)) {
        return null;
    }
    return transactionImport.data;
};
//# sourceMappingURL=selectors.js.map